import styled, { keyframes } from 'styled-components';
import { basicColor, font, padding, radius } from '@/styles/template';

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const SuccessMessage = styled.p`
    ${font.basicBoldS}
    color: ${basicColor.secondaryDark};
    background: ${basicColor.secondaryTransparent};
    border-radius: ${radius.normal};
    padding: ${padding.small};
    width: 100%;
`;

export const FixedSuccessMessage = styled(SuccessMessage)`
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    background: ${basicColor.secondaryTransparent};
    padding: ${padding.normal};
    border-radius: ${radius.large};
    animation: ${fadeOut} 5s forwards;  // Анимация исчезновения
    z-index: 9999;
`;

export default SuccessMessage;